import React from "react";
import "./Know_Your_Plan_Component.css";
import { Table } from "react-bootstrap";

const Know_Your_Plan_Component = ({ val, IMG_URL }) => {
  const featureData = [
    {
      label: "99.2%",
      descn: "of all claims filed last year were settled by Profcyma Finance",
      note_text: "",
      img: "/assets/Image/Plan_Details/know_your_plan/cardimg1.png",
    },
    {
      label: "High",
      descn: "Solvency Ratio: Industry leading claims paying capacity",
      note_text: "",
      img: "/assets/Image/Plan_Details/know_your_plan/cardimg2.png",
    },
    {
      label: "30 Days",
      descn: "Easy refund in free Look Period in case you change your mind",
      note_text: "(deductions applicable basis T&C)",
      img: "/assets/Image/Plan_Details/know_your_plan/cardimg3.png",
    },
    {
      label: "Tax Saving",
      descn:
        "Save tax upto ₹46,800 every year under Section 80C. Also claims disbursed are non taxable.",
      note_text: "*T&C Apply",
      img: "/assets/Image/Plan_Details/know_your_plan/cardimg4.png",
    },
  ];

  return (
    <div className="Know_Your_Plan_Component">
      <p className="title_text">About Plan</p>

      <p className="subtext">{val?.about_plane}</p>

      <div className="row">
        <div className="col-lg-6 col-12">
          <div className="covered_main_div">
            <div className="blue_div">
              <p className="div_title">What's Covered</p>
            </div>

            <p className="descn">{val?.what_cover}</p>
          </div>
        </div>

        <div className="col-lg-6 col-12">
          <div className="covered_main_div not_covered">
            <div className="blue_div">
              <p className="div_title">What's Not Covered</p>
            </div>

            <p className="descn">{val?.what_not_cover}</p>
          </div>
        </div>
      </div>

      <div className="policy_plan_steps_div">
        <div className="first_div">
          <div className="row">
            {val?.insurance_disadvantage_details?.map((val) => (
              <div className="col-lg-3 col-md-8 col-sm-10 col-12">
                <div className="policy_start_div">
                  <div className="img_holder">
                    <img
                      src={`${IMG_URL}${val?.insurance_disadvantage?.image}`}
                      className="img"
                    />
                  </div>

                  <div className="text_holder">
                    <p className="text1">{val?.insurance_disadvantage?.name}</p>
                  </div>
                </div>
              </div>
            ))}
            {/* <div className="col-lg-3 col-md-8 col-sm-10 col-12">
              <div className="policy_start_div">
                <div className="img_holder">
                  <img
                    src="/assets/Image/Plan_Details/know_your_plan/img1.png"
                    className="img"
                  />
                </div>

                <div className="text_holder">
                  <p className="text1">Policy Starts</p>
                  <p className="text2">You pay ₹651/m</p>
                </div>

                <p className="policy_start_text">Age 70 yrs </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-8 col-sm-10 col-12">
              <div className="policy_start_div policy_middle_div">
                <div className="img_holder">
                  <img
                    src="/assets/Image/Plan_Details/know_your_plan/img2.png"
                    className="img"
                  />
                </div>

                <div className="text_holder">
                  <p className="text1">
                    In case of your untimely death, your family will get life
                    cover of ₹25 Lac, tax-free
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-8 col-sm-10 col-12">
              <div className="policy_start_div policy_end_div">
                <div className="img_holder">
                  <img
                    src="/assets/Image/Plan_Details/know_your_plan/img3.png"
                    className="img"
                  />
                </div>

                <div className="text_holder">
                  <p className="text1">Policy Coverage Ends</p>
                </div>

                <p className="policy_end_text">Age 70 yrs </p>
              </div>
            </div> */}
          </div>
        </div>

        {/* <div className='row'>
                    <div className='col-4'>
                        <p className='step_first_text step_common_text'>Age 33 yrs</p>
                    </div>
                    <div className='col-4'>
                        <p className='setp_middle_text step_common_text'></p>
                    </div>
                    <div className='col-4'>
                        <p className='step_last_text step_common_text'>Age 70 yrs</p>
                    </div>
                </div> */}
      </div>

      <div className="feature_card_holder">
        <div className="row">
          {val?.insurance_advantage_details?.map((item) => {
            return (
              <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                <div className="feature_card">
                  <div className="img_holder">
                    <img
                      src={IMG_URL + item?.insurance_advantage?.image}
                      className="img"
                    />
                  </div>
                  <div className="content_holder">
                    <p className="title">{item?.insurance_advantage?.name}</p>
                    <p className="descn">
                      {item?.insurance_advantage?.sub_name}
                    </p>
                    <p className="note_text">
                      {item?.insurance_advantage?.note}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="footer_content_div table-responsive">
        <Table responsive>
          <thead className="">
            <tr>
              <th>Why buy Online?</th>
              <th className="right_th">Online</th>
              <th className="right_th">Offline</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p className="td_text_right text_left">Cover Term</p>
              </td>
              <td>
                <p className="td_text_right">{val?.cover_till_age} Years</p>
              </td>
              <td>
                <p className="td_text_right">{val?.cover_till_age} Years</p>
              </td>
            </tr>

            <tr>
              <td>
                <p className="td_text_right text_left">Premiuim</p>
              </td>
              <td>
                <p className="td_text_right">
                  {" "}
                  {val?.f_i_amounts?.find(
                    (addOn) => addOn.f_insurance_type_id === 2
                  )?.online_amount
                    ? `${
                        val.f_i_amounts.find(
                          (addOn) => addOn.f_insurance_type_id === 2
                        ).online_amount
                      }  ₹/monthly`
                    : ""}
                </p>
                <p className="td_subtext">
                  {/* or{" "} */}
                  {val?.f_i_amounts?.find(
                    (addOn) => addOn.f_insurance_type_id === 1
                  )?.online_amount
                    ? `${
                        val.f_i_amounts.find(
                          (addOn) => addOn.f_insurance_type_id === 1
                        ).online_amount
                      }  ₹/ year`
                    : ""}
                </p>
              </td>
              <td>
                <p className="td_text_right">
                  {" "}
                  {val?.f_i_amounts?.find(
                    (addOn) => addOn.f_insurance_type_id === 2
                  )?.offline_amount
                    ? `${
                        val.f_i_amounts.find(
                          (addOn) => addOn.f_insurance_type_id === 2
                        ).offline_amount
                      }  ₹/monthly`
                    : ""}
                </p>
                <p className="td_subtext">
                  {/* or{" "} */}
                  {val?.f_i_amounts?.find(
                    (addOn) => addOn.f_insurance_type_id === 1
                  )?.offline_amount
                    ? `${
                        val.f_i_amounts.find(
                          (addOn) => addOn.f_insurance_type_id === 1
                        ).offline_amount
                      }  ₹/ year`
                    : ""}
                </p>
              </td>
            </tr>

            <tr>
              <td>
                <p className="td_text_right text_left">LifeTime Impact</p>
              </td>
              <td>
                <p className="td_text_green td_text_right">
                  {(
                    ((val?.f_i_amounts[0]?.offline_amount -
                      val?.f_i_amounts[0]?.online_amount) /
                      val?.f_i_amounts[0]?.offline_amount) *
                    100
                  ).toFixed(0)}
                  % Online Discount
                </p>
              </td>
              <td>
                <p className="td_text_red td_text_right">
                  Pay{" "}
                  {(
                    (val?.f_i_amounts[0]?.offline_amount -
                      val?.f_i_amounts[0]?.online_amount) /
                    1000
                  ).toFixed(1)}
                  K extra
                </p>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default Know_Your_Plan_Component;
